let map;

const mapElement = document.getElementById('google_map');

// Style Google Maps N&B (grayscale)
const MAP_STYLES_BW = [
  { elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 10 }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ saturation: -100 }, { lightness: 20 }] },
  { elementType: 'labels.text.stroke', stylers: [{ saturation: -100 }, { lightness: 80 }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 25 }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ lightness: 15 }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ lightness: 20 }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 60 }] }
];

const PIN_COLOR = '#561F1F';

function toNumberSafe(value) {
  const n = Number(String(value ?? '').trim().replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

function escapeHtml(str) {
  return String(str ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function getTextFrom(tile, selectors) {
  for (const sel of selectors) {
    const el = tile.querySelector(sel);
    if (el && el.textContent && el.textContent.trim()) return el.textContent.trim();
  }
  return '';
}

function getFirstLink(tile, selectors) {
  for (const sel of selectors) {
    const el = tile.querySelector(sel);
    if (el && el.href) return el.href;
  }
  return '';
}

function getFirstImage(tile) {
  const img = tile.querySelector('img');
  return img?.currentSrc || img?.src || '';
}

// HTML du pop-up
function buildInfoContent(store) {
  const title = escapeHtml(store.title);
  const address = escapeHtml(store.address);
  const tel = escapeHtml(store.tel);
  const image = store.image ? escapeHtml(store.image) : '';

  const directions =
    store.directions ||
    `https://maps.google.com/?q=${store.lat},${store.lng}`;

  const telHref = store.tel
    ? `tel:${store.tel.replace(/[^\d+]/g, '')}`
    : '';

  return `
    <div class="sl-iw">
      ${image ? `<div class="sl-iw__media"><img src="${image}" alt="${title}" loading="lazy"></div>` : ''}
      <div class="sl-iw__body">
        ${title ? `<div class="sl-iw__title">${title}</div>` : ''}
        ${address ? `<div class="sl-iw__address">${address}</div>` : ''}

        <div class="sl-iw__actions">
          <a class="sl-iw__btn sl-iw__btn--outline" href="${directions}" target="_blank" rel="noopener">
            Directions
          </a>

          ${tel ? `
            <a class="sl-iw__btn sl-iw__btn--outline" href="${telHref}">
              ${tel}
            </a>
          ` : ''}
        </div>
      </div>
    </div>
  `;
}

// ✅ IMPORTANT: callback global pour Google Maps
window.initiateGoogleMap = async function initiateGoogleMap() {
  if (!mapElement) return;

  // Les tiles (aside + slider)
  const asideCards = document.querySelectorAll('.store-locator-cards__aside-filtered');
  const sliderCards = document.querySelectorAll('.store-locator-cards__filtered');

  // On crée les points à partir des cards à gauche (aside)
  const stores = Array.from(asideCards)
    .map((tile) => {
      const latEl = tile.querySelector('.store-locator-card__latitude');
      const lngEl = tile.querySelector('.store-locator-card__longitude');

      const lat = toNumberSafe(latEl?.textContent);
      const lng = toNumberSafe(lngEl?.textContent);
      if (lat === null || lng === null) return null;

      // 🔥 On récupère le contenu directement dans la card (sans data-attrs)
      const title =
        tile.dataset.storeTitle ||
        getTextFrom(tile, [
          '.store-locator-card__title',
          '.store-locator__title',
          'h3',
          'h4'
        ]);

      const address =
        tile.dataset.storeAddress ||
        getTextFrom(tile, [
          '.store-locator-card__address',
          '.store-locator__address',
          'address'
        ]);

      const tel =
        tile.dataset.storeTel ||
        getTextFrom(tile, [
          '.store-locator-card__tel',
          '.store-locator__tel',
          'a[href^="tel:"]'
        ]) ||
        // dernier fallback: si un numéro est dans le texte
        (tile.textContent.match(/(\+\d[\d\s().-]{6,})/) || [])[0] ||
        '';

      const directions =
        tile.dataset.storeDirections ||
        getFirstLink(tile, [
          'a[href*="google.com/maps/dir"]',
          'a[href*="maps.google.com"]',
          'a[href*="google.com/maps"]'
        ]);

      const image = tile.dataset.storeImage || getFirstImage(tile);

      return { tile, lat, lng, title, address, tel, directions, image };
    })
    .filter(Boolean);

  if (!stores.length) return;

  if (typeof google === 'undefined' || typeof google.maps === 'undefined') return;

  const mapZoomLevelElement = document.getElementById('map-zoom-level');
  let mapZoomLevel = 4;
  if (mapZoomLevelElement) mapZoomLevel = Number(mapZoomLevelElement.innerHTML) || 4;
  const mapZoomLevelUnit = mapZoomLevel <= 18 ? 3 : 0;

  const lats = stores.map(s => s.lat);
  const lngs = stores.map(s => s.lng);
  const centerLatitude = (Math.min(...lats) + Math.max(...lats)) / 2;
  const centerLongitude = (Math.min(...lngs) + Math.max(...lngs)) / 2;

  map = new google.maps.Map(mapElement, {
    zoom: mapZoomLevel,
    center: { lat: centerLatitude, lng: centerLongitude },
    scrollwheel: true,
    gestureHandling: 'greedy',
    disableDefaultUI: true,
    styles: MAP_STYLES_BW
  });

  const infowindow = new google.maps.InfoWindow({ maxWidth: 340 });

  const setMapClickHandler = (item, store) => {
    if (!item) return;
    item.addEventListener('click', function () {
      map.panTo(new google.maps.LatLng(store.lat, store.lng));
      map.setZoom(mapZoomLevel + mapZoomLevelUnit);
    });
  };

  // ✅ Pin "goutte" (beau pin)
  const PIN_PATH = "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z";

  stores.forEach((store, index) => {
    setMapClickHandler(asideCards[index], store);
    setMapClickHandler(sliderCards[index], store);

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(store.lat, store.lng),
      map,
      title: '',
      icon: {
        path: PIN_PATH,
        fillColor: PIN_COLOR,
        fillOpacity: 1,
        strokeColor: PIN_COLOR,
        strokeOpacity: 1,
        strokeWeight: 1,
        scale: 1.7,
        anchor: new google.maps.Point(12, 24)
      }
    });

    marker.addListener('click', () => {
      infowindow.setContent(buildInfoContent(store));
      infowindow.open(map, marker);
      map.panTo(marker.getPosition());
    });
  });
};
